import { Footer as FBFooter } from 'flowbite-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div>
      <FBFooter container className='bg-gray-100 rounded-none'>
        {/* Mobile layout */}
        <div className='flex flex-col items-center gap-2 lg:hidden'>
          {/* Links */}
          <FBFooter.LinkGroup className='flex gap-4 justify-center'>
            <FBFooter.Link href='/about'>About</FBFooter.Link>
            <FBFooter.Link href='/contact'>Contact</FBFooter.Link>
          </FBFooter.LinkGroup>

          {/* Copyright */}
          <FBFooter.Copyright
            by='Price Brothers Equipment Company'
            year={currentYear}
          />

          {/* Disclaimer */}
          <p className='text-center text-xs text-gray-500 px-4'>
            Prices and availability subject to change without notice.
          </p>
        </div>

        {/* Desktop layout */}
        <div className='hidden lg:flex lg:flex-row lg:justify-between lg:items-center w-full'>
          <FBFooter.Copyright
            by='Price Brothers Equipment Company'
            year={currentYear}
          />

          <p className='text-center text-xs text-gray-500 px-4'>
            Prices and availability subject to change without notice.
          </p>

          <FBFooter.LinkGroup className='flex gap-4 justify-center'>
            <FBFooter.Link href='/about'>About</FBFooter.Link>
            <FBFooter.Link href='/contact'>Contact</FBFooter.Link>
          </FBFooter.LinkGroup>
        </div>
      </FBFooter>
    </div>
  );
}
